@if (!isLoading || !useSpinner) {
  <oui-autocomplete
    label="Enveloppe"
    [control]="enveloppeControl"
    [options]="enveloppeAutocompleteOptions"
    [displayResetButton]="true"
  class="width-100pc"></oui-autocomplete>
  <oui-autocomplete
    #searchProduit
    label="Produit"
    [control]="produitControl"
    [options]="produitAutocompleteOptions"
    [allowCustomValue]="false"
    [displayResetButton]="true"
  class="width-100pc"></oui-autocomplete>
}
<div class="flex-horizontal align-self-center">
  @if (isLoading && useSpinner) {
    <oui-loading></oui-loading>
  }
</div>
